import React from 'react'
import { Card } from '@mui/material'

import { fireRef } from 'src/firebase'
import { Cards } from 'src/legacy/components/mui'
import { Container } from 'src/designSystem'
import ScrollContainer from 'src/legacy/components/ScrollContainer'
import { useToasts } from 'react-toast-notifications'
import { ApolloError } from '@apollo/client'
import Coaches from './Coaches'
import ReferralTypes from './ReferralTypes'
import Sources from './Sources/Sources'
import Tags from './Tags/Tags'
import { useCreateCoachMutation, useDeleteCoachMutation, useUpdateCoachEmailMutation } from './adminQueries.generated'

const addReferral = (title: string) => fireRef.child('referralTypes').push({ title })
const deleteReferral = (id: string) => fireRef.child('referralTypes').child(id).remove()

const Admin: React.FunctionComponent = () => {
  const [createCoach] = useCreateCoachMutation()
  const [deleteCoach] = useDeleteCoachMutation()
  const [updateCoachEmail] = useUpdateCoachEmailMutation()
  const { addToast } = useToasts()

  const deleteCoachFn = (coachID: string) => {
    deleteCoach({ variables: { coachID } }).catch((error) => {
      if (error instanceof ApolloError) {
        const graphQLError = error.graphQLErrors[0]
        if (graphQLError?.extensions?.code === 'FOREIGN_KEY_CONSTRAINT_VIOLATION') {
          addToast(graphQLError.message || 'Cannot delete coach: related data exists')
        } else if (graphQLError?.extensions?.clientError) {
          addToast(error.message)
        } else {
          addToast('Failed to delete coach')
        }
      } else {
        addToast('Failed to delete coach')
      }
    })
  }

  return (
    <Container>
      <ScrollContainer>
        <Cards>
          <Card>
            <Coaches
              addFn={(email) => createCoach({ variables: { email } })}
              deleteFn={deleteCoachFn}
              updateEmailFn={(coachID, email) => updateCoachEmail({ variables: { coachID, email } })}
            />
          </Card>
          <Card>
            <Sources />
          </Card>
          <Card>
            <ReferralTypes addFn={addReferral} deleteFn={deleteReferral} />
          </Card>
          <Card>
            <Tags />
          </Card>
        </Cards>
      </ScrollContainer>
    </Container>
  )
}

export default Admin
